"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      form: {
        wx_account_name: '',
        wx_account_qrcode: '',
        zfb_account_name: '',
        zfb_account_qrcode: '',
        withdraw_type: 1
      },
      money: {},
      freezVisible: false,
      noWithdraw: false,
      plan_date: ['每天', '每周', '每月'],
      week: ['日', '一', '二', '三', '四', '五', '六'],
      withdraw_plan: {}
    };
  },
  computed: {
    agentInfo: function agentInfo() {
      var agentInfo = this.$store.getters.agentInfo;
      this.form.wx_account_name = agentInfo.wx_account_name;
      this.form.wx_account_qrcode = agentInfo.wx_account_qrcode;
      this.form.zfb_account_name = agentInfo.zfb_account_name;
      this.form.zfb_account_qrcode = agentInfo.zfb_account_qrcode;
      return agentInfo;
    },
    siteInfo: function siteInfo() {
      var siteInfo = this.$store.getters.siteInfo;
      siteInfo.agent_withdraw_type = [0, 1, 2, 3, 4];
      if (siteInfo.agent_id) this.form.withdraw_type = siteInfo.agent_withdraw_type[0];
      return siteInfo;
    }
  },
  mounted: function mounted() {
    this.getMoney();
    this.verifyWithdraw();
    this.$store.dispatch('user/postSetRecode', [3, 1, 4]);
    console.log(this.form);
  },
  methods: {
    verifyWithdraw: function verifyWithdraw() {
      var _this = this;
      var siteInfo = this.siteInfo;
      this.$get('agentapi/apply/verify_withdraw_alvalie').then(function (res) {
        if (res.status == 1) {
          _this.noWithdraw = true;
          _this.withdraw_plan = _this.checkRoles(['merchants']) ? siteInfo.withdraw_plan.merchant : siteInfo.withdraw_plan.agent;
        }
      });
    },
    getMoney: function getMoney() {
      var _this2 = this;
      this.$get('agentapi/index').then(function (res) {
        _this2.money = res;
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;
      if (!this.form.withdraw_money) {
        this.$message.error('请输入提现金额');
        return;
      } else if (parseFloat(this.form.withdraw_money) > parseFloat(this.money.available_withdraw_money)) {
        this.$message.error('余额不足');
        return;
      }
      this.$post('agentapi/launch_withdraw_apply', this.form).then(function (res) {
        _this3.$message({
          message: '申请成功',
          type: 'success'
        });
        _this3.$router.push({
          path: '/withdraw/record'
        });
      });
    }
  }
};